import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/config/siteConfig";
import { useSiteSettings, apiImg } from "@/lib/siteSettings";
import { scrollToId } from "@/lib/scroll";
import { Reveal } from "@/components/Reveal";

export const About = () => {
  const { site } = useSiteSettings();
  const heading = site?.aboutHeading || "Real Estate, Made Simpler.";
  const desc1 =
    site?.aboutDesc ||
    "RK Real Estate helps buyers, sellers, tenants and property owners navigate their real estate requirements with professional assistance and a customer-focused approach.";
  const desc2 =
    site?.aboutDesc2 ||
    "Whether you're looking for a home, a commercial space, a plot or a rental property, we're here to make your property journey more straightforward.";
  const image = site?.aboutImage ? apiImg(site.aboutImage) : IMAGES.about;

  return (
    <section id="about" className="bg-white py-16 sm:py-24 lg:py-28 overflow-hidden" data-testid="about-section">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal className="relative">
          <div className="absolute -top-4 -left-4 w-full h-full rounded-xl border-2 border-gold/50" aria-hidden="true" />
          <div className="relative rounded-xl overflow-hidden aspect-[4/3] shadow-[0_30px_70px_rgba(11,31,51,0.18)]">
            <img src={image} alt="About RK Real Estate" loading="lazy" className="w-full h-full object-cover" data-testid="about-image" />
          </div>
          <div className="absolute -bottom-6 -right-3 sm:-right-6 bg-navy rounded-xl px-6 py-5 shadow-xl">
            <p className="font-display text-2xl sm:text-3xl font-semibold text-gold">Buy • Sell • Rent</p>
            <p className="mt-1 text-[11px] tracking-[0.2em] uppercase text-white/60">One trusted partner</p>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <span className="inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.24em] text-gold">
              <span className="h-px w-8 bg-gold" /> About RK Real Estate
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-[2.7rem] font-semibold text-navy leading-[1.15] tracking-tight" data-testid="about-heading">
              {heading}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 text-sm sm:text-base lg:text-lg text-ink-soft leading-relaxed whitespace-pre-line" data-testid="about-desc">{desc1}</p>
          </Reveal>
          <Reveal delay={0.24}>
            <p className="mt-4 text-sm sm:text-base lg:text-lg text-ink-soft leading-relaxed whitespace-pre-line">{desc2}</p>
          </Reveal>
          <Reveal delay={0.32}>
            <button
              onClick={() => scrollToId("#contact")}
              data-testid="about-know-more-button"
              className="mt-8 bg-gold text-navy hover:bg-gold-dark hover:-translate-y-0.5 transition-all duration-300 rounded-lg px-7 py-3.5 text-[15px] font-semibold inline-flex items-center gap-2 shadow-md shadow-gold/25"
            >
              Know More About Us <ArrowRight size={16} />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
